// Added by Sejune Oh on 2020-06-11
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    ListItemIcon as MaterialUIListItemIcon,
    ListItemIconProps as MaterialUIListItemIconProps
} from '@material-ui/core'

interface ListItemIconBaseProps { }
export type ListItemIconProps = Partial<MaterialUIListItemIconProps> & ListItemIconBaseProps

export const ListItemIcon: FC<ListItemIconProps> = ({ ...rest }) => {
    // @ts-ignore
    return <MaterialUIListItemIcon {...rest}></MaterialUIListItemIcon>
}
